"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getString = void 0;

var _strings = require("../../../../config/strings");

var STRINGS = {
  SEND_ANSWER: {
    de: 'Antwort abgeben',
    en: 'Send answer'
  },
  MC_WARNING_TEXT: {
    de: 'Die aktuelle Frage könnte mehr als eine richtige Antwort haben! Wollen Sie fortfahren?'
  },
  MC_WARNING_TITLE: {
    de: 'Aufgepasst!'
  }
};

function addStringsToGlobalList() {
  if (!_strings.addStrings) {
    console.log('addStrings is still null');
    setTimeout(addStringsToGlobalList, 50);
    return;
  } // console.log('addstrings is possible now')


  (0, _strings.addStrings)(STRINGS);
}

addStringsToGlobalList(); // named export for better import proposals by webstorm

var getString = function getString() {
  return _strings.getString.apply(void 0, arguments);
};

exports.getString = getString;